import { render, staticRenderFns } from "./ProductAddons.vue?vue&type=template&id=5b8ab6d5&"
import script from "./ProductAddons.vue?vue&type=script&lang=js&"
export * from "./ProductAddons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports